import {IPaylodAction} from '../interfaces/dispatchers'
import {IApplication} from '../interfaces/reducers'
import ApplicationActions from '../enums/ActionTypes/ApplicationActions'

const initState = {} as any
const application = (state: IApplication = initState, action: IPaylodAction) => {
  switch (action.type) {
    case ApplicationActions.WINDOW_RESIZED:
      return {...state, mobile: action.payload}
    default:
      return state
  }
}
export default application
